module.exports = __webpack_public_path__ + "img/Iconos_09.a41a66da.png";